import { Pipe, PipeTransform } from '@angular/core';
import { DateChecker } from '../model/dateValidation.model';

@Pipe({
  name: 'dateChecker',
})
export class DateCheckerPipe implements PipeTransform {
  transform(dateString: string): DateChecker {
    let newValue: DateChecker;
    const desiredValue = dateString.substring(dateString.indexOf(':') + 1).trim();
    if (dateString) {
      const dateTimeWithSecondsRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
      const dateTimeWithoutSecondsRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/;
      // Backend ISO 8601 values (the V2 leg-log snapshot serializes DateTimes this way). The trailing
      // Z is OPTIONAL: Utc-kind values carry it (2026-07-31T19:54:04.888Z) while Unspecified-kind
      // values serialize without it (2026-07-31T19:54:04.888). The fractional-seconds part is also
      // optional and of any precision. Both parse as UTC in srTimezoneDate/localDate (moment.utc), so
      // recognition here is the only gate deciding whether the panel formats or shows the raw string.
      const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/;

      // Check if the desiredValue matches the date formats strictly
      const isValidDateFormat =
        dateTimeWithSecondsRegex.test(desiredValue) || dateTimeWithoutSecondsRegex.test(desiredValue) || isoUtcRegex.test(desiredValue);

      if (isValidDateFormat) {
        newValue = {
          isDate: true,
          value: desiredValue,
        };
      } else {
        newValue = {
          isDate: false,
          value: desiredValue,
        };
      }
    } else {
      newValue = {
        isDate: false,
        value: desiredValue,
      };
    }
    return newValue;
  }
}
